import React from "react"

export const Content = (props) => {
  const { name, count } = props

  return (
    <React.Fragment>
      <figure>
        <img
          src="https://prod-etr.s3.amazonaws.com/images/assets/folder_icon.png"
          width="27px"
          height="21px"
        />
      </figure>
      <header className="folder-name">{name}</header>
      <p className="file-count">
        {count} {count > 1 || count == 0 ? "Files" : "File"}
      </p>
    </React.Fragment>
  )
}

export const FavoriteFolderFrame = (props) => {
  const { className = "", style, children } = props
  return (
    <article className={`favorite-folder-frame ${className}`} style={style}>
      {children}
    </article>
  )
}

export const PreviewFrame = (props) => {
  return <article className="folder-preview-frame">{props.children}</article>
}

export const Col = (props) => {
  return (
    <section className="col" style={props.style}>
      {props.children}
    </section>
  )
}
